import cx from 'classnames'
import { ReactNode } from 'react'

import styles from './displayValue.module.css'

interface Props {
  label: string
  value: ReactNode
  small?: boolean
  className?: string
}

const DisplayValue = ({ label, value, small, className }: Props) => {
  return (
    <div className={cx(styles.displayValue, className)}>
      <label>{label}</label>
      <p className={cx(styles.value, small && styles.small)}>{value}</p>
    </div>
  )
}

export default DisplayValue
